//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from "lodash-es";
import { mapGetters, mapMutations } from "vuex";

import TransitionExpand from '../global/transitions/Expand.vue';

import AppFilters from './components/Filters.vue';
import AppTags from './components/Tags.vue';
import AppResultCount from './components/ResultCount.vue';
import AppResults from './components/Results.vue';
import AppPagination from './components/Pagination.vue';
import AppViewToggle from './components/ResultViewToggle';
import AppTrendingSearches from './components/TrendingSearches.vue';

export default {
	components: {
		TransitionExpand,
		AppFilters,
		AppResultCount,
		AppTags,
		AppResults,
		AppPagination,
		AppViewToggle,
		AppTrendingSearches
	},
	data() {
		return {
			currentQuery: "",
			dataLayerActive: false
		}
	},
	computed: {
		...mapGetters([
			"query",
			"results",
			"loaded",
			"siteName",
			"reloading",
			"resultView",
			"aboveMdBreakpoint",
			"filters",
		]),
		classes() {
			return {
				"reloading": this.reloading,
				"app--list-minimal": this.config.defaultResultView == "list-minimal",
				"app--calendar": this.resultView == "calendar" && this.aboveMdBreakpoint,
				"app--trending": this.config.showTrendingSearches && !!this.config.trendingSearchEndpoint
			}
		}
	},
	methods: {
		...mapMutations(["setStateValue", "extend"]),
		dataLayerSearchPush() {
			if (this.dataLayerActive) {
				let data = {
					'event': 'search_submit',
					'query': this.query
				}
				dataLayer.push(data);
				this.currentQuery = this.query
			}
		},
	},
	watch: {
		results(newResults, oldResults) {
			if (!!newResults.queryUsed?.searchTerm && newResults.queryUsed.searchTerm !== this.currentQuery) {
				this.dataLayerSearchPush();
			}
		},
		query(newQuery, oldQuery) {
			//we compare the current input of the search field against the query param in the url. If it's different, it's a new search term.
			let firstTimeQuery = false;
			if (!!newQuery && newQuery !== this.results.queryUsed?.searchTerm) {
				firstTimeQuery = true;
			}
			
			this.extend(extended => {
					let obj = cloneDeep(extended);
					obj.firstTimeQuery = firstTimeQuery;
					return obj;
				});
		}
	},
	created() {
		if (!!this.config.allowResultViewToggling && !!this.config.defaultResultView) {
			this.setStateValue(["resultView", this.config.defaultResultView]);
		} else if (!!this.config.defaultResultView) this.setStateValue(["resultView", this.config.defaultResultView]);
		else this.setStateValue(["resultView", "grid"]);
		
		if (window.dataLayer) this.dataLayerActive = true;

		if (!!document.querySelector(".page--RM")) this.setStateValue(["siteName", "RM"]);
		if (!!document.querySelector(".page--ORG, .page--TXC, .page--TSP, .page--BOB, .page--BUY")) this.setStateValue(["siteName", "ORG"]);
		if(this.config.siteNameOverride) this.setStateValue(["siteName", this.config.siteNameOverride]);
	},
	mounted() {
		window.addEventListener("resize", () => {
			this.setStateValue(["aboveMdBreakpoint", window.innerWidth > 768]);
		});
	},
}
